"use client";

import type { RPNPageQueryResult } from "@homeinstead/schemas";

import { cn } from "@homeinstead/ui";
import { Hero } from "~care/components/app/landing/Hero";
import CareSeekerNationalLeadForm from "~care/components/ui/LeadForm/CareSeekerShallowLeadForm/CareSeekerNationalLeadForm";
import { useIsDebug } from "~care/hooks/useIsDebug";
import { useMultiStepForm } from "~care/hooks/useMultiStepForm";

// Note that the displayed step and the actual step is off by 1 because the first step is hidden.
// Also, the final step is a Thank You page.
const INITIAL_STEP = 2;
const FINAL_STEP = 6;

export const RPNHero = ({
  className,
  pageData,
}: {
  className?: string;
  pageData: RPNPageQueryResult;
}) => {
  const { isDebug } = useIsDebug();

  const careSeekerShallowForm = useMultiStepForm({
    finalStep: FINAL_STEP,
    initialStep: INITIAL_STEP,
  });

  if (!pageData) {
    return null;
  }

  return (
    <Hero className={cn(className, "bg-clear-sky-tints-800")}>
      <CareSeekerNationalLeadForm
        className="bg-clear-sky-tints-800 xl:w-full"
        currentStep={careSeekerShallowForm.currentStep}
        finalStep={FINAL_STEP}
        handleBack={careSeekerShallowForm.prevStep}
        handleNext={careSeekerShallowForm.nextStep}
        isDebug={isDebug}
        leadSource="RPN"
        rating={pageData?.rating || undefined}
        subtitle={pageData.leadFormSubtitle}
        title={pageData.leadFormTitle}
      />
    </Hero>
  );
};
